import { HttpErrorResponse } from "@angular/common/http";

import { Message } from "@core/models/message.model";
import { TPagination } from "@custom-types/sorting";
import { createAction, props } from "@ngrx/store";

export const LOAD_MESSAGES = createAction(
  "[Messages] Load Messages",
  props<{ pagination?: Partial<TPagination> }>()
);

export const SET_MESSAGES = createAction(
  "[Messages] Set Messages",
  props<{ messageList: Array<Message> }>()
);

export const SET_MESSAGES_LOADING_STATUS = createAction(
  "[Messages] Set Messages Loading Status",
  props<{ loading: boolean }>()
);

export const SET_MESSAGES_ERROR = createAction(
  "[Messages] Set Messages Error",
  props<{ error: HttpErrorResponse }>()
);

export const DOWNLOAD_MESSAGE_ATTACHMENT = createAction(
  "[Messages] Load Message Attachment",
  props<{ message: Message }>()
);

export const SAVE_MESSAGE = createAction(
  "[Messages] Save Message",
  props<{
    message: Partial<Message>;
    image?: File;
    userId?: string;
    intermediaryId?: string;
    productVersionId?: string;
    productId?: string;
  }>()
);

export const SET_MESSAGES_PAGINATION = createAction(
  "[Messages] Set Messages Pagination",
  props<{ pagination: Partial<TPagination> | undefined }>()
);

export const SET_MESSAGES_LENGTH = createAction(
  "[Messages] Set Messages Length",
  props<{ length: number }>()
);
